import { HTMLAttributes } from 'react';
import { Container } from './_Content';

interface Props extends HTMLAttributes<HTMLDivElement> {}

export const Content = ({ children }: Props) => {
  return <Container>{children}</Container>;
};
